"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Frequency = exports.UserActionsTypeWithMedia = exports.UserActionsType = void 0;
var UserActionsType;
exports.UserActionsType = UserActionsType;

(function (UserActionsType) {
  UserActionsType["FEED_MESSAGE"] = "feed_message";
  UserActionsType["FEED_ACTIVITY_SHARE"] = "feed_activity_share";
  UserActionsType["CHALLENGE_SUCCESS"] = "challenge_success";
  UserActionsType["REFERRAL_SUCCESS"] = "referral_success";
  UserActionsType["BONUS_APPLIED"] = "bonus_applied";
})(UserActionsType || (exports.UserActionsType = UserActionsType = {}));

var UserActionsTypeWithMedia;
exports.UserActionsTypeWithMedia = UserActionsTypeWithMedia;

(function (UserActionsTypeWithMedia) {
  UserActionsTypeWithMedia["FEED_MESSAGE"] = "feed_message";
  UserActionsTypeWithMedia["FEED_MESSAGE_WITH_MEDIA"] = "feed_message_with_media";
  UserActionsTypeWithMedia["FEED_ACTIVITY_SHARE"] = "feed_activity_share";
  UserActionsTypeWithMedia["FEED_ACTIVITY_SHARE_WITH_MEDIA"] = "feed_activity_share_with_media";
  UserActionsTypeWithMedia["CHALLENGE_SUCCESS"] = "challenge_success";
  UserActionsTypeWithMedia["REFERRAL_SUCCESS"] = "referral_success";
})(UserActionsTypeWithMedia || (exports.UserActionsTypeWithMedia = UserActionsTypeWithMedia = {}));

var Frequency;
exports.Frequency = Frequency;

(function (Frequency) {
  Frequency["WEEK"] = "week";
  Frequency["MONTH"] = "month";
  Frequency["DAY"] = "day";
})(Frequency || (exports.Frequency = Frequency = {}));
//# sourceMappingURL=types.js.map